export const InquiryLabel = "Inquiry";
export const InquiryDetailsTitle = "Inquiry Details";
export const UpdateInquiryTitle = "Update Inquiry";

export const SearchInquiryPlaceholder = "Search Inquiry";

export const FullNameLabel = "Full Name";
export const CompanyNameLabel = "Company Name";
export const EmailLabel = "Email";
export const StatusLabel = "Status";
export const ReasonForContactLabel = "Reason For Contact";
export const MessageLabel = "Message";
export const RemarksLabel = "Remarks";
export const ActionsLabel = "Actions";

export const ViewLabel = "View";
export const UpdateLabel = "Update";

export const SubmitUpdateLabel = "Update";

export const INQUIRY_STATUS_OPTIONS = [
  { value: "Pending", label: "Pending" },
  { value: "In Progress", label: "In Progress" },
  { value: "Completed", label: "Completed" },
];

export const ACCESSOR_KEYS = {
  FULL_NAME: "fullName",
  COMPANY_NAME: "companyName",
  EMAIL: "email",
  STATUS: "status",
  ACTIONS: "actions",
};
